<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2022-06-07 11:47:06
 * @LastEditors: lau
 * @LastEditTime: 2022-06-24 11:13:28
-->
<!-- 设添加黑名单接口内容 -->
<template>
  <div class>
    <right-structure :Pdatas="infoData">
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
import structure from "@/components/commonStructure";

export default {
  name: "",
  components: {
    "right-structure": structure
  },
  props: ["commonUrls"],
  data() {
    return {
      requestBody: {
        parkCodeList: ["2KNTYVWC"],
        carCode: "粤YKK123",
        carOwner: "车主",
        pageSize:1,
        pageNum:10
      },
      responseCode: {
        data: {
            blacklistId: 1
        },
        message: "业务成功",
        resultCode: 0,
        status: 1
      },
      infoData: {
        explain: "第三方接入系统请求智慧停车开放平台查询黑名单车辆列表",
        t_url: this.commonUrls.test + "getParkBlackList",
        p_url: this.commonUrls.prod + "getParkBlackList",
          precondition: "",
          fitSystem: "VEMS传统停车场，云停车场",
        pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
        Q_params: [
          {
            titleName: null,
            tabledata: [
              { tableHead: "参数名", tdName: "info1" },
              { tableHead: "是否必填", tdName: "info2" },
              { tableHead: "类型", tdName: "info3" },
              { tableHead: "说明", tdName: "info4" }
            ],
            td: [
              {
                info1: "parkCodeList",
                info2: "是",
                info3: "JSONArray",
                info4:
                  "停车场编号列表"
              },
          
              { info1: "carCode", info2: "否", info3: "String", info4: "车牌" },
              {
                info1: "owner",
                info2: "否",
                info3: "String",
                info4: "车主名称"
              },
              {
                info1: "validFrom",
                info2: "否",
                info3: "String",
                info4: "有效时间起始(yyyyMMddHHmmss)"
              },
              {
                info1: "validTo",
                info2: "否",
                info3: "String",
                info4: "截止时间起始(yyyyMMddHHmmss)"
              },
              {
                info1: "pageSize",
                info2: "否",
                info3: "Integer",
                info4:
                  "每页多少条(默认10，最多1000)"
              },
              {
                info1: "pageNum",
                info2: "否",
                info3: "Integer",
                info4: "页码(默认1)"
              }                   
            ]
          }
        ],
        R_params: [
          {
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'total', info2: '否', info3: 'Integer', info4: '总数'},
              {info1: 'currCount', info2: '否', info3: 'Integer', info4: '当前记录数'},
              {info1: 'recordList', info2: '否', info3: 'Integer', info4: '黑名单列表'}

            ]
          },
          {
            titleName: "recordList",
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号码'},
              {info1: 'owner', info2: '否', info3: 'String', info4: '车主姓名'},
              {info1: 'specialCarTypeConfigName', info2: '否', info3: 'String', info4: '黑名单类型名称'},
              {info1: 'specialCarTypeConfigId', info2: '是', info3: 'String', info4: '黑名单类型名称'},
              {info1: 'blacklistForeverFlag', info2: '否', info3: 'String', info4: '黑名单生效期类型(0:自定义，1永久)'},
              {info1: 'reason', info2: '否', info3: 'String', info4: '黑名单原因'},
              {info1: 'createTime', info2: '否', info3: 'yyyyMMddHHmmss', info4: '创建时间'},
              {info1: 'validFrom', info2: '否', info3: 'yyyyMMddHHmmss', info4: '开始时间'},
              {info1: 'validTo', info2: '否', info3: 'yyyyMMddHHmmss', info4: '截止时间'},
            ]
          }
        ],
        codeStatus: [
          {
            titleName: null,
            tabledata: [
              { tableHead: "状态码", tdName: "info1" },
              { tableHead: "说明", tdName: "info2" }
            ],
            td: [
              { info1: "000110", info2: "失败" },
              { info1: "00110000", info2: "失败" },
              { info1: "110000", info2: "失败" }
            ]
          }
        ]
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
/* @import "../../assets/less/conmon.less"; */
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/blacklist/getParkBlackList.vue